module.exports = __webpack_public_path__ + "img/more.3379f37c.svg";